import { isAddress, } from "./Address";
import {
	chains,
	type ValidChainId,
} from "@bracket/chainography";


export declare type TokenAddress = `0x${string}`;


export const isTokenAddress = ( value:unknown, chain:ValidChainId = 1 ): value is TokenAddress => {
	if(isAddress(value)) {
		for(const tok of Object.values(chains[chain].tokens)) {
			if(tok.address.toLowerCase() === value.toLowerCase()) {
				return true;
			}
		}
	}
	return false;
}
